import { GenerateOTPRequestImpl } from "src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotprequest";
import { GenerateOTPResponse } from "src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotpresponse";
import { SetStatusToneRequestImpl } from "src/com/sixdee/crbtportal/core/api/statustune/setstatustune/setstatustonepricerequest";
import { SetStatusToneResponse } from "src/com/sixdee/crbtportal/core/api/statustune/setstatustune/setstatustonepriceresponse";
import { GetTonePriceRequestImpl } from "src/com/sixdee/crbtportal/core/api/tune/gettuneprice/gettonepricerequest";
import { GetTonePriceResponse } from "src/com/sixdee/crbtportal/core/api/tune/gettuneprice/gettonepriceresponse";
import { BuyToneDto } from "src/com/sixdee/crbtportal/core/dto/buytone/buytonedto";
import { GetTonePriceDtoImpl } from "src/com/sixdee/crbtportal/core/dto/gettoneprice/gettonepricedto";
import { GenerateOTPDtoImpl } from "src/com/sixdee/crbtportal/core/dto/otp/generateotp/generateotpdto";
import { SendOTPDto } from "src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto";
import { ProfileToneDto } from "src/com/sixdee/crbtportal/core/dto/profiletune/profiletonedto";
import { ToneDto } from "src/com/sixdee/crbtportal/core/dto/tonedto";
import { ToneProcessorFactory } from "src/com/sixdee/crbtportal/core/processorfactory/toneprocessorfactory";
import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { APIModel, APIModelHandler, APIModelImpl } from "../../../toolkit/uicomponentapimodel";

export interface ProfileToneAPIModel extends APIModel 
{
    // buyTone(buyToneDto: BuyToneDto): void;
    // buyMusicChannelAPI(buyToneDto: BuyToneDto): void;
    getTonePrice(toneDto: ToneDto): void;
    getOTP(createAccountOtpDto: SendOTPDto): void ;
    getTonePriceNonLoggedInuser(giftDto:BuyToneDto): void;

}

export class ProfileToneAPIModelImpl extends APIModelImpl implements ProfileToneAPIModel 
{
    private toneProcessor: ToneProcessorFactory;
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) 
    {
        super(applicationContext, apiModelHandler);
        this.toneProcessor = this.getAPIProcesssorFactory().getToneProcessorFactory();
    }

    getOTP(createAccountOtpDto: SendOTPDto): void 
    {
      let generateOtp = new GenerateOTPDtoImpl();
      generateOtp.setMsisdn(createAccountOtpDto.getMsisdn());

        this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().generateOTP()
                .success((generateOTPResponse : GenerateOTPResponse)=>
                {
                    this.getAPIModelHandler().onSuccess(generateOTPResponse.getAPIFeature(), 
                    generateOTPResponse.getDescription(), generateOTPResponse);
                })
                .failure((generateOTPResponse : GenerateOTPResponse)=>
                {
                    this.getAPIModelHandler().onFailure(generateOTPResponse.getAPIFeature(), 
                         generateOTPResponse.getDescription(), generateOTPResponse);

                }).execute(new GenerateOTPRequestImpl(generateOtp));
    }
    setStatusTone(dto: ProfileToneDto): void 
    {
        this.toneProcessor.getSetStatusToneProcessor()
        .success((buyResponse : SetStatusToneResponse)=>
         {
            this.getAPIModelHandler().onSuccess(buyResponse.getAPIFeature(), 
            buyResponse.getDescription(), buyResponse);
         })
       .failure((buyResponse : SetStatusToneResponse)=>
       {
           this.getAPIModelHandler().onFailure(buyResponse.getAPIFeature(), 
           buyResponse.getDescription(), buyResponse);
         })
       .execute(new SetStatusToneRequestImpl(dto));
    }

    getTonePrice(toneDto: ToneDto): void 
    {
      console.log("get tone price");
      
        let getTonePriceDto =  new GetTonePriceDtoImpl();
        getTonePriceDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getTonePriceDto.setServiceId("1");
        getTonePriceDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        getTonePriceDto.setToneId(toneDto.getId());
        getTonePriceDto.setValidationIdentifier("3");
        getTonePriceDto.setChannelId(this.getContext().getUserContext().getChannelId());

        this.toneProcessor.getGetTonePriceAPIProcessor()
        .success((getTonePriceResponse : GetTonePriceResponse)=>
         {
            this.getAPIModelHandler().onSuccess(getTonePriceResponse.getAPIFeature(), 
            getTonePriceResponse.getDescription(), getTonePriceResponse.getGetTonePriceDto().getToneDetailsList()[0]);
         })
       .failure((getTonePriceResponse : GetTonePriceResponse)=>
       {
           this.getAPIModelHandler().onFailure(getTonePriceResponse.getAPIFeature(), 
           getTonePriceResponse.getDescription(), getTonePriceResponse);
         })
       .execute(new GetTonePriceRequestImpl(getTonePriceDto));
    }

    getTonePriceNonLoggedInuser(giftDto:BuyToneDto): void 
    {
      console.log("channeld"+this.getContext().getUserContext().getChannelId());
        let getTonePriceDto =  new GetTonePriceDtoImpl();
        getTonePriceDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getTonePriceDto.setServiceId("1");
        getTonePriceDto.setAPartyMsisdn(giftDto.getMsisdn());
        getTonePriceDto.setToneId(giftDto.getToneId());
        getTonePriceDto.setValidationIdentifier("3");
        getTonePriceDto.setChannelId(this.getContext().getUserContext().getChannelId());

        this.toneProcessor.getGetTonePriceAPIProcessorNonLoggedInUser()
        .success((getTonePriceResponse : GetTonePriceResponse)=>
         {
            this.getAPIModelHandler().onSuccess(getTonePriceResponse.getAPIFeature(), 
            giftDto.getMsisdn(), getTonePriceResponse.getGetTonePriceDto().getToneDetailsList()[0]);
         })
       .failure((getTonePriceResponse : GetTonePriceResponse)=>
       {
           this.getAPIModelHandler().onFailure(getTonePriceResponse.getAPIFeature(), 
           getTonePriceResponse.getDescription(), getTonePriceResponse);
         })
       .execute(new GetTonePriceRequestImpl(getTonePriceDto));
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/profiletone/profiletoneapimodel.ts